import { useUserData } from 'components/contexts/UserDataContext'
import { useAuth0 } from 'utils/auth'

import { flagUserId } from './flagUserId'

/** The identity `App.controller` identifies to LaunchDarkly, so readiness checks wait for that same key. */
export const useFlagUserId = (): string | undefined => {
  const { isAuthenticated, user } = useAuth0()
  const { baseUserData } = useUserData()
  return flagUserId(isAuthenticated, user?.email, baseUserData?.email)
}
